







































































































































































































































































































































































































































































































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";

import ReportExportPane from "@/components/Agencies/ReportExportPane.vue";
import {
  AutomaticReportForm,
  ReportNameField,
  SingleReport,
  TemplateDeleteModal,
  TemplateFlowBanner,
  TemplateFlowCancelButton,
  TemplateSelect,
} from "@/components/Agencies/ReportBuilder";
import { automaticReportFormInitialState } from "@/components/Agencies/ReportBuilder/automaticReport";
import { dateRangeString } from "@/components/Agencies/ReportBuilder/templateParameters";
import DialogModal from "@/components/DialogModal.vue";
import GrpTargetSelect from "@/components/GrpTargetSelect.vue";
import MessagePanel from "@/components/MessagePanel.vue";
import MultiLevelSelect from "@/components/MultiLevelSelect.vue";
import BroadcasterSelect from "@/components/Report/BroadcasterSelect.vue";
import ReportSubjectSelect from "@/components/Report/SubjectSelect.vue";
import VCheckbox from "@/components/VCheckbox.vue";
import VCheckButtonRadio from "@/components/VCheckButtonRadio.vue";
import VIcon from "@/components/VIcon.vue";
import VModal from "@/components/VModal.vue";
import VMultiSwitcher from "@/components/VMultiSwitcher.vue";
import VVerticalSteps from "@/components/VVerticalSteps.vue";
import { AUTOMATIC_REPORTS_ENABLED } from "@/constants";
import AutomaticReportSchedulingMixin from "@/mixins/ReportBuilder/AutomaticReportSchedulingMixin";
import {
  ReportBuilderTabKey,
  isReportBuilderTabKey,
} from "@/mixins/ReportBuilder/ReportBuilderMixin";

@Component({
  components: {
    GrpTargetSelect,
    DialogModal,
    VModal,
    MultiLevelSelect,
    VCheckButtonRadio,
    ReportSubjectSelect,
    BroadcasterSelect,
    VCheckbox,
    ReportExportPane,
    SingleReport,
    AutomaticReportForm,
    TemplateSelect,
    TemplateDeleteModal,
    ReportNameField,
    VVerticalSteps,
    VMultiSwitcher,
    VIcon,
    MessagePanel,
    TemplateFlowBanner,
    TemplateFlowCancelButton,
  },
})
export default class AgenciesCustomReportExporter extends Mixins(
  AutomaticReportSchedulingMixin
) {
  broadcastersLoading = false;
  subjectsLoading = false;

  async created(): Promise<void> {
    const { tab } = this.$route.query;
    if (
      isReportBuilderTabKey(tab) &&
      this.visibleTabItems.some((item) => item.id === tab)
    ) {
      this.activeTab = tab;
    }
    if (this.$route.query.edit) {
      if (AUTOMATIC_REPORTS_ENABLED) {
        await this.onAutomaticReportEdit(String(this.$route.query.edit));
      }
    } else if (this.$route.query.editTemplate) {
      await this.onTemplateEdit(String(this.$route.query.editTemplate));
    } else if (this.$route.query.newTemplate) {
      this.onCreateFromBuilder();
    }
  }

  get dateRangeString(): string {
    return dateRangeString(this.parameters);
  }

  onTabClick(id: string) {
    if (id === this.activeTab) return;
    if (this.isTemplateFlow || this.editingAutomaticReportId !== null) {
      this.restart();
    } else {
      this.exitBulkDeleteMode();
    }
    this.switchTab(id);
  }

  onBroadcasterSelectAllApplied() {
    this.pendingSelectAll.broadcasters = false;
    this.pendingSelectAll.agencies = false;
  }

  onSubjectSelectAllApplied() {
    this.pendingSelectAll.productTypes = [];
    this.pendingSelectAll.sectorTypes = [];
  }

  cancelTemplateFlow() {
    if (this.schedulingAutomaticReport) {
      this.cancelAutomaticScheduling();
      return;
    }
    this.restart();
    if (this.returnToTemplateSettings()) return;
    this.activeTab = ReportBuilderTabKey.ReportTemplate;
  }

  restart() {
    this.exitEditMode();
    this.exitAutomaticEditMode();
    this.exitBulkDeleteMode();
    this.deselectTemplate();
    this.schedulingAutomaticReport = false;
    this.scheduleTemplateName = "";
    this.automaticReportForm = automaticReportFormInitialState();
    this.reset();
  }

  @Watch("profile.slug")
  async onProfileChanged() {
    try {
      this.maxDate = await this.loadProfileDate();
    } catch {
      this.maxDate = "";
    } finally {
      this.restart();
    }
  }
}
